module.exports = __webpack_public_path__ + "static/media/yoga2.4d806175.webp";